var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5725 11.8425L27.4312 11.2431H14.4037V16.7569H22.1875C21.3794 20.5944 17.6294 22.6144 14.5662 22.6144C12.3375 22.6144 9.98812 21.6769 8.43312 20.17C7.61271 19.3623 6.95966 18.4006 6.51137 17.3402C6.06308 16.2797 5.82835 15.1413 5.82062 13.99C5.82062 11.6675 6.86438 9.34437 8.38313 7.81625C9.90188 6.28813 12.1956 5.43313 14.4762 5.43313C17.0881 5.43313 18.96 6.82 19.66 7.4525L23.5781 3.555C22.4287 2.545 19.2712 0 14.35 0C10.5531 0 6.9125 1.45438 4.25125 4.10687C1.625 6.71875 0.265625 10.4956 0.265625 14C0.265625 17.5044 1.55188 21.0925 4.09688 23.725C6.81625 26.5325 10.6675 28 14.6331 28C18.2413 28 21.6612 26.5863 24.0987 24.0212C26.495 21.4963 27.7344 18.0025 27.7344 14.34C27.7344 12.7981 27.5794 11.8825 27.5725 11.8425Z",
    fill: "#BC4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.933328d0adb97d6d4fb8dcf95e6fd491.svg";
export { ForwardRef as ReactComponent };